// AWS Amplify Authentication
import { Amplify } from 'aws-amplify';
import { signIn, signOut, getCurrentUser, fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';

// Configuration from legacy code
const CONFIG = {
    region: 'us-east-1',
    userPoolId: 'us-east-1_1HX1EmdvB',
    clientId: '352459hbv85ult7allefvf4aud',
    identityPoolId: 'us-east-1:607c7f59-b032-4a96-ac04-411429b2a139'
};

// Configure Amplify
Amplify.configure({
    Auth: {
        Cognito: {
            region: CONFIG.region,
            userPoolId: CONFIG.userPoolId,
            userPoolClientId: CONFIG.clientId,
            identityPoolId: CONFIG.identityPoolId
        }
    }
});

class Auth {
    constructor() {
        // Amplify is configured globally, no need for client instances
    }

    // Sign in user
    async signIn(username, password) {
        try {
            const result = await signIn({
                username,
                password
            });

            console.log('Authentication successful');
            return result;
        } catch (error) {
            console.error('Authentication failed:', error);
            throw error;
        }
    }

    // Sign out user
    async signOut() {
        try {
            await signOut();
            console.log('Sign out successful');
        } catch (error) {
            console.error('Sign out error:', error);
            throw error;
        }
    }

    // Check if user is authenticated
    async isAuthenticated() {
        try {
            const user = await getCurrentUser();
            return !!user;
        } catch (error) {
            return false;
        }
    }

    // Get current user info
    async getCurrentUser() {
        try {
            const user = await getCurrentUser();
            const attributes = await fetchUserAttributes();

            return {
                username: attributes.preferred_username || attributes.email || user.username,
                userId: user.userId,
                email: attributes.email
            };
        } catch (error) {
            console.error('Error getting current user:', error);
            return null;
        }
    }

    // Get AWS credentials for S3 access
    async getAWSCredentials() {
        try {
            const session = await fetchAuthSession();
            return session.credentials;
        } catch (error) {
            console.error('Error getting AWS credentials:', error);
            throw error;
        }
    }
}

export default Auth;